import React from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './infoDetailRecommendHeader.module.scss';

const cx = classnames.bind(styles);

const InfoDetailRecommendHeader = () => {
  return (
    <div className={cx('sectionTitleArea')}>
      <Link href={RouteUrl.INFO_LIST} legacyBehavior>
        <a className={cx('sectionTitle')} role="button">
          당신이 좋아할 콘텐츠만 잡아봤어요.
          <Icon name="arrowRightLight" width={32} height={32} />
        </a>
      </Link>
    </div>
  );
};

export default InfoDetailRecommendHeader;
